import { render, staticRenderFns } from "./Crearcontacto.vue?vue&type=template&id=61efbbfc&"
import script from "./Crearcontacto.vue?vue&type=script&lang=js&"
export * from "./Crearcontacto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports